import React, { Component, Fragment } from 'react';
import withImmutablePropsToJS from 'with-immutable-props-to-js';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { studentCompleteProfile } from 'containers/StudentUpdateProfile/actions';
import TriggerSaveAccount from 'containers/Account/TriggerSaveAccount';
import FormDetail from './../FormDetail';
import { getCurrentAccount } from 'containers/Account/actions';
import { uploadAvatar } from 'utilities/file';
import { trimObjectList } from 'utilities/handleValues';
import { getResources } from 'containers/Resources/actions';
import { request } from 'utilities/Api';
import { openRequestEventReasonPopUpRequest } from 'containers/RequestEventRessonPopUp/action';
import { completeProfilePopUp } from 'components/StudentFirstJoinEventProfileForm/action';
import _get from 'lodash/get';

class FormDetailContainer extends Component {

  constructor(props) {
    super(props);
    this.state = {
      tagList: []
    }
  }

  completeProfilePopUp = (msg) => {
    if (msg === 'COMPLETE_PROFILE_TO_JOIN_EVENT')
    this.props.completeProfilePopUp();

  }

  componentWillReceiveProps() {
    if (!this.props.tag) {
			this.props.getResources();
    } else {
      const tagList = this.props.tag.map((value) => value.name);
      this.setState({
        tagList: tagList
      });
    }
  }

  async handleUploadFile(file) {
    try {
      const image = await uploadAvatar(file);
      const { objectId } = await request('classes/Image', {
        file: { ...image, '__type': 'File' },
        type: 'AVATAR',
        name: image.name
      }, 'POST');
      return objectId || null;
    } catch (e) {
      return null;
    }
  }

  submit = async (values) => {
    const data = values.toJS();
    const { sessionToken } = this.props;
    this.props.studentCompleteProfile(trimObjectList(data), sessionToken);
  }

  render() {
    const { currentUser } = this.props;
    const initialValues = {
      avatarId: (currentUser.avatarImage && currentUser.avatarImage.objectId) || '',
      lastName: currentUser.lastName,
      firstName: currentUser.firstName,
      lastNameHiragana: currentUser.lastNameHiragana,
      firstNameHiragana: currentUser.firstNameHiragana,
      phone: currentUser.phone,
      email: currentUser.email,
      studentProfile: {
        ...currentUser.studentProfile,
        district: _get(currentUser, 'studentProfile.district._id')
      }
    };
    return (
      <Fragment>
        <FormDetail
          initialValues={initialValues}
          uploadFile={this.handleUploadFile}
          onSubmit={this.submit}
          currentUser={currentUser}
          tag={this.state.tagList}
        />
        <TriggerSaveAccount endSaveAccount={this.completeProfilePopUp} />
      </Fragment>
    );
  }
}

FormDetailContainer.propTypes = {
  history: PropTypes.object,
  getCurrentAccount: PropTypes.func,
  currentUser: PropTypes.object,
  studentCompleteProfile: PropTypes.func,
  getResources: PropTypes.func,
  tag: PropTypes.array
};

const mapStateToProps = state => {
  return {
    currentUser: state.get('account').get('data'),
    sessionToken: state.get('account').get('token'),
    tag: state.get('resources').get('industries')
  };
};

const mapDispatchToProps = dispatch => ({
  getCurrentAccount: (token) => dispatch(getCurrentAccount(token)),
  studentCompleteProfile: (values, sessionToken) => dispatch(studentCompleteProfile(values, sessionToken, 'COMPLETE_PROFILE_TO_JOIN_EVENT')),
  completeProfilePopUp: () => dispatch(completeProfilePopUp()),
  openRequestEventReasonPopUpRequest: () => dispatch(openRequestEventReasonPopUpRequest()),
  getResources: () => dispatch(getResources(['Industry']))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withImmutablePropsToJS(FormDetailContainer));